import React, { useState, useEffect } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
// import * as wjCore from '@mescius/wijmo'
import * as wjMultiRow from '@mescius/wijmo.react.grid.multirow'
import { FlexGridFilter } from '@mescius/wijmo.grid.filter'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import customContextMenu from '../../wijmo/customContextMenu'
import { KeyAction } from '@mescius/wijmo.grid'
import { idPresentation, contractTypePresentation } from '../../utility'
import moment from 'moment'
import ErrorBoundary from '../ErrorBoundary'
import BootstrapAlert from '../element/BootstrapAlert'

function colLayout (isShopro) {
  const colBase = {
    cssClassAll: 'wj-style-basic',
    isReadOnly: true,
    width: 110
  }
  const idCellTemp = (ctx) => `<div class="zero-padding">${idPresentation(ctx.value)}</div>`
  const layout = [
    {
      colspan: 1,
      cells: [
        {
          ...colBase,
          binding: 'sp_memo',
          header: 'ShoPro社内メモ',
          rowspan: 2,
          cssClassAll: 'wj-style-basic-input',
          align: 'center',
          width: 80,
          isReadOnly: false,
          maxLength: 40,
          wordWrap: true
        }
      ]
    },
    {
      colspan: 1,
      cells: [
        {
          ...colBase,
          binding: 'id',
          header: '申請ID',
          align: 'left',
          cellTemplate: (ctx) => `<a href="${ctx.item.uri}">${idPresentation(ctx.value)}</a>`,
          width: 90,
          rowspan: 2
        }
      ]
    },
    isShopro
      ? {
          colspan: 2,
          cells: [
            { ...colBase, binding: 'applied_at', header: '申請日時', width: 160 },
            { ...colBase, binding: 'approver_name', header: '承認者', width: 110 },
            { ...colBase, binding: 'completed_at', header: '最終承認日時', width: 160 },
            { ...colBase, binding: 'wf_state', header: 'ステータス', width: 110 }
          ]
        }
      : {
          colspan: 1,
          cells: [
            { ...colBase, binding: 'applied_at', header: '申請日時', width: 150 },
            { ...colBase, binding: 'wf_state', header: 'ステータス', width: 150 }
          ]
        },
    isShopro
      ? {
          colspan: 2,
          cells: [
            { ...colBase, binding: 'contract.sp_user.department.name', header: '事業部', width: 100 },
            { ...colBase, binding: 'contract.sp_user.division.name', header: '課', width: 100 },
            { ...colBase, binding: 'contract.sp_user.name', header: 'ShoPro担当者', width: 100 },
            { ...colBase, binding: 'contract.sp_user.position_comment', header: '担当者属性', width: 100 }
          ]
        }
      : null,
    isShopro
      ? {
          colspan: 2,
          cells: [
            { ...colBase, binding: 'user.company_id', header: '会社ID', align: 'left', cellTemplate: idCellTemp },
            { ...colBase, binding: 'user.company.name', header: '会社名', width: 150 },
            { ...colBase, binding: 'user_id', header: '申請者ID', align: 'left', cellTemplate: idCellTemp },
            { ...colBase, binding: 'user.name', header: '申請者名', width: 150 }
          ]
        }
      : null,
    {
      colspan: 1,
      cells: [
        { ...colBase, binding: 'contract.character.title', header: 'キャラクター', width: 150 },
        { ...colBase, binding: 'contract_type', header: '契約方式', width: 150 }
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colBase, binding: 'item_info', header: 'アイテム', width: 150, align: 'left' },
        { ...colBase, binding: 'release_at_info', header: '発売日（最短）', width: 150, align: 'left' }
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colBase, binding: 'downloaded_at_info', header: 'ダウンロード状況', width: 170, align: 'left' },
        { ...colBase, binding: 'exist_trade_info', header: '製造申請状況', width: 170, align: 'left' }
      ]
    },
    {
      colspan: 1,
      cells: [
        {
          ...colBase,
          binding: 'uri',
          header: ' ',
          rowspan: 2,
          align: 'center',
          width: 90,
          cellTemplate: (ctx) => {
            return `<a href="${ctx.text}" class="btn bg-theme-success py-0">詳細</a>`
          },
          allowSorting: false
        }
      ]
    }
  ].filter((col) => col)
  return {
    def: layout,
    frozenColumns: 0
  }
}

function getWfState (workflow, isShopro) {
  if (isShopro) {
    if (workflow) {
      if (workflow.is_returned) {
        return '差戻し'
      } else if (workflow.is_approver) {
        return '未承認'
      } else if (workflow.is_approved) {
        return '承認済'
      } else {
        return '承認待ち'
      }
    } else {
      return 'ルート未設定'
    }
  } else {
    if (workflow) {
      if (workflow.is_approved) {
        return '承認済'
      } else if (workflow.is_returned) {
        return '差戻し'
      } else {
        return '確認中'
      }
    } else {
      return '確認中'
    }
  }
}

function setWfStateStyle (cell, isShopro) {
  if (isShopro) {
    switch (cell.innerHTML) {
      case 'ルート未設定':
        cell.classList.add('bg-default')
        break
      case '未承認':
        cell.classList.add('bg-default')
        break
      case '承認待ち':
        cell.classList.add('bg-default')
        break
      case '承認済':
        cell.classList.add('bg-default')
        break
      case '差戻し':
        cell.classList.add('bg-danger', 'text-white')
        break
      default:
        break
    }
  } else {
    switch (cell.innerHTML) {
      case '承認済':
        cell.classList.add('bg-default')
        break
      case '確認中':
        cell.classList.add('bg-default')
        break
      case '差戻し':
        cell.classList.add('bg-danger', 'text-white')
        break
      default:
        break
    }
  }
}

export default function ApplicationListStampData (props) {
  const [layoutDef] = useState(colLayout(props.isShopro))
  const [errorMessage, setErrorMessage] = useState(null)

  // インポート/エクスポート時のテーブルを定義
  const tableFormat = [
    { field: 'id', text: '申請ID', type: 'string', isEditable: false },
    { field: 'applied_at', text: '申請日時', type: 'string', isEditable: false },
    { field: 'wf_state', text: 'ステータス', type: 'string', isEditable: false },
    { field: 'user.company.name', text: '会社名', type: 'string', isEditable: false },
    { field: 'contract.sp_user.name', text: 'ShoPro担当者名', type: 'string', isEditable: false },
    { field: 'character_title', text: 'キャラクター', type: 'string', isEditable: false },
    { field: 'contract_type', text: '契約方式', type: 'string', isEditable: false },
    { field: 'item_info', text: 'アイテム', type: 'string', isEditable: false },
    { field: 'release_at_info', text: '発売日（最短）', type: 'string', isEditable: false }
  ]

  const applications = props.applications.map((application) => {
    application.id = `${application.id}`
    application.wf_state = getWfState(application.workflow, props.isShopro)

    const contract = application.contract
    if (contract.character.is_default) {
      contract.character.title = '★' + contract.character_name_free
    }
    application.character_title = contract.character.title
    application.contract_type = contract ? (contract.xr_contract_id ? 'クロスリクープ' : contractTypePresentation(contract.contract_type)) : ''

    if (application.applied_at) {
      application.applied_at = moment(application.applied_at).format('YYYY-MM-DD HH:mm:ss')
    }

    if (application.items) {
      // アイテム情報を作成
      if (application.items.length === 1) {
        application.item_info = `1点（${application.items[0].item.name}）`
      } else {
        application.item_info = `${application.items.length}点（${application.items[0].item.name} 他）`
      }
      // 発売日情報を作成
      application.release_at_info = application.items
        .map((item) => item.release_at)
        .reduce((prev, current) => prev < current ? prev : current)
      // ダウンロード済み情報・製造申請済み情報を作成
      const downloadedAtCount = [0, 0]
      const existTradeCount = [0, 0]
      application.items
        .forEach((item) => {
          downloadedAtCount[item.downloaded_at ? 1 : 0] += 1
          existTradeCount[item.exist_trade ? 1 : 0] += 1
        })
      application.downloaded_at_info = downloadedAtCount[0] === 0
        ? '完了'
        : `未完了あり（${downloadedAtCount[0]}件/${downloadedAtCount[0] + downloadedAtCount[1]}件）`
      application.exist_trade_info = existTradeCount[0] === 0
        ? '完了'
        : `未申請あり（${existTradeCount[0]}件/${existTradeCount[0] + existTradeCount[1]}件）`
    }

    return application
  })

  useEffect(() => {
  }, [])

  const initializeGrid = (flex) => {
    flex.formatItem.addHandler((s, e) => {
      if (e.panel === s.columnHeaders) return
      const col = s.columns[e.col]
      if (col.binding === 'trade.contract_type') {
        switch (e.cell.innerHTML) {
          case 'アイテム個別':
            e.cell.classList.add('bg-default')
            break
          case 'グロス':
            e.cell.classList.add('bg-default')
            break
          case 'クロスリクープ':
            e.cell.classList.add('bg-default')
            break
          default:
            break
        }
      }
      if (col.binding === 'wf_state') {
        setWfStateStyle(e.cell, props.isShopro)
      }
    })

    flex.cellEditEnding.addHandler((s, e) => {
      const row = e.getRow()
      const item = row.dataItem
      const col = s.columns[e.col]
      if (col.binding === 'sp_memo') {
        if (!window.confirm('メモを更新しますか？')) {
          e.cancel = true
          return
        }
        const newValue = s.activeEditor.value
        const elCsrf = document.querySelector('meta[name="csrf-token"]')
        const form = new FormData()
        form.append('_token', elCsrf.content)
        form.append('id', item.id)
        form.append('sp_memo', newValue)
        form.append('updated_at', item.updated_at)
        fetch(`${props.editUrl}`, {
          method: 'POST',
          body: form
        })
          .then((response) => response.json())
          .then((data) => {
            if (!data.error_message) {
              elCsrf.content = data._token
              item.sp_memo = data.fields.sp_memo
              item.updated_at = moment(data.fields.updated_at).format('YYYY-MM-DD HH:mm:ss')
              s.refreshRange(e.range)
            } else {
              setErrorMessage(data.error_message)
            }
          })
          .finally(() => {
          })
          .catch((error) => {
            setErrorMessage('データの更新中にエラーが発生しました。')
            console.error(error)
          })
      }
    })

    const _filter = new FlexGridFilter(flex)
    _filter.filterColumns = layoutDef.def.flat()
      .map((col) => col.cells).flat()
      .map((cell) => cell.binding)
      .filter((binding) => binding !== 'application_uri')

    flex.tableFormat = tableFormat

    // コンテキストメニュー設定
    customContextMenu(flex)
  }

  return (
    <div className="d-inline-block w-100">
      {errorMessage && (
        <BootstrapAlert class='danger'>
          <div>{errorMessage}</div>
        </BootstrapAlert>
      )}
      <wjMultiRow.MultiRow showMarquee={true} stickyHeaders={true} itemsSource={applications} layoutDefinition={layoutDef.def}
        frozenColumns={layoutDef.frozenColumns} keyActionTab={KeyAction.Cycle} initialized={initializeGrid}
        style={{ maxHeight: '500px' }}>
      </wjMultiRow.MultiRow>
    </div>
  )
}

ApplicationListStampData.propTypes = {
  applications: PropTypes.arrayOf(PropTypes.object),
  isShopro: PropTypes.bool,
  editUrl: PropTypes.string
}

ApplicationListStampData.defaultProps = {
  isShopro: false,
  editUrl: PropTypes.string
}

$('#application-list-stamp-data').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <ApplicationListStampData {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
